import { __rest } from "tslib";
import React from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import Dropdown from '../../../../../BaseComponents/Dropdown';
const DropdownDirections = (_a) => {
    var { field, options, addOption, deleteOption, filterOptions } = _a, otherProps = __rest(_a, ["field", "options", "addOption", "deleteOption", "filterOptions"]);
    const { t } = useTranslation('Traveller');
    const { InputProps: inputProps } = otherProps, dropdownProps = __rest(otherProps, ["InputProps"]);
    return (React.createElement(Field, { name: field.queryFieldName, render: ({ input, meta }) => {
            var _a;
            const resetInput = () => input.onChange('');
            const onChange = (_, value) => {
                if (typeof value !== 'string') {
                    addOption(field.arrayFieldName, value);
                }
                resetInput();
            };
            return (React.createElement(Dropdown, Object.assign({ value: null, options: options, onChange: onChange, onOpen: resetInput, onClose: resetInput, blurOnSelect: false, disableCloseOnSelect: true, disableClearable: true, disablePortal: true, disabled: (options === null || options === void 0 ? void 0 : options.length) === ((_a = field.selectedOptions) === null || _a === void 0 ? void 0 : _a.length), filterOptions: options => filterOptions(options.filter((opt) => typeof opt !== 'string'), input.value, field.selectedOptions), isOptionEqualToValue: (opt, value) => typeof opt !== 'string' && typeof value !== 'string' && opt.value === value.value, noOptionsText: field.selectedAll
                    ? t('You have selected all available cities')
                    : t('City not found. Try a different query'), InputProps: Object.assign(Object.assign(Object.assign({}, input), inputProps), { label: field.label, error: meta.error && meta.touched, helperText: inputProps.helperText && field.selectedAll
                        ? inputProps.helperText
                        : meta.touched && t(meta.error) }) }, dropdownProps)));
        } }));
};
export default DropdownDirections;
